import React from 'react'
import { getButtonStyle, getButtonHoverStyle } from '../styles'

const ActionButton = ({ 
  onClick, 
  backgroundColor, 
  hoverColor, 
  children, 
  title, 
  style = {} 
}) => {
  const baseStyle = getButtonStyle(backgroundColor)
  const hoverStyle = getButtonHoverStyle(hoverColor)

  const handleMouseOver = (e) => {
    Object.assign(e.target.style, hoverStyle)
  }

  const handleMouseOut = (e) => {
    e.target.style.backgroundColor = backgroundColor
    e.target.style.transform = 'scale(1)'
  }

  const handleFocus = (e) => {
    Object.assign(e.target.style, hoverStyle)
  }

  const handleBlur = (e) => {
    e.target.style.backgroundColor = backgroundColor
    e.target.style.transform = 'scale(1)'
  }

  return (
    <button
      type="button"
      onClick={onClick}
      style={{ ...baseStyle, ...style }}
      onMouseOver={handleMouseOver}
      onFocus={handleFocus}
      onMouseOut={handleMouseOut}
      onBlur={handleBlur}
      title={title}
    >
      {children}
    </button>
  )
}

export default ActionButton 